<template>
  <div class="flex items-center gap-2 ml-auto">
    <span class="text-xs font-semibold">{{ name }}:</span>
    <div class="flex items-center">
      <label class="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          class="sr-only peer"
          :checked="modelValue"
          @change="$emit('update:modelValue', $event.target.checked)"
        >
        <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-primary-500
            peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-2
            peer-checked:after:translate-x-full
            after:content-['']
            after:absolute after:top-[2px]
            after:left-[2px]
            after:bg-white after:border
            after:rounded-full after:h-5
            after:w-5
            after:transition-all">
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    name: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
}
</script>
